import React, { Component } from "react";
import { Link } from "react-router-dom";
import RoundController from "./RoundController";
import RoundsTable from "./rounds_table/RoundsTable";
import UsersTable from "./users_table/UsersTable";
import RoundChanger from "./RoundChanger";
import ImportFromQuill from "./ImportFromQuill";
import {
  Grid,
  Header,
  Segment,
  Button,
  Statistic,
  Dimmer,
  Loader,
  Input,
  Form
} from "semantic-ui-react";
import AdminApi from "../utils/AdminApi";
import UserApi from "../utils/UserApi";
import Storage from "../utils/Storage";
import SettingsControl from "./SettingsControl";
import ApplyFAIR from "./ApplyFAIR";
import ScoringConstantControl from "./ScoringConstantControl";

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rounds: [],
      current_round: "",
      users: [],
      loading: true,
      settings: []
    };
    this.handleChangeRound = this.handleChangeRound.bind(this);
    this.handleNumberChange = this.handleNumberChange.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  handleNumberChange(event) {    
    this.setState({target_num: event.target.value});  
  }

  handleChangeRound(new_round) {
    AdminApi.setRound(new_round).then((response) => {
      window.location.reload();
      // console.log(response);
    });
  }

  componentDidMount() {
    if (this.state.loading) {
      this.refresh();
    }
  }

  refresh() {
    AdminApi.getRounds().then((response) => {
      this.setState({
        rounds: response.data.rounds,
        current_round: response.data.current_round,
      });
      UserApi.getUsers().then((response) => {
        this.setState({
          users: response.data,
        });
        AdminApi.getSettings().then((response) => {
          this.setState({
            settings: response.data,
            loading: false,
          });
          console.log("hi here r the settings", response.data);
        });
      });
    });
  }

  //  downloadAdmitData = () => {
  // 	fetch('http://0.0.0.0:5000/scoring/generate-scores?round_number=' + this.state.current_round.round_number)
  // 		.then(response => {
  // 			response.blob().then(blob => {
  //          console.log('response fetched')
  // 				let url = window.URL.createObjectURL(blob);
  // 				let a = document.createElement('a');
  //          a.href = url;
  //          let rd = this.state.current_round.round_number;
  // 				a.download = 'round_'+rd+'_admits.csv';
  // 				a.click();
  // 			});
  // 			//window.location.href = response.url;
  // 	});
  // }
  downloadAdmitData = (targetNum, admitTeams, nepThresh, mitFreshAuto, nepAuto, nepEmails) => {
    AdminApi.generateScores(this.state.current_round.round_number, 
                            {'target_num': targetNum, 'admit_teams': admitTeams, 'nep_thresh': nepThresh, 'admit_mit_fresh': mitFreshAuto, 'admit_neps': nepAuto, 'nep_emails': nepEmails.join(" ")})
    .then(
      (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "round_" + this.state.current_round.round_number + ".csv"
        );
        document.body.appendChild(link);
        link.click();
        //window.location.href = response.url;
      }
    );
  };

  exportScores = () => {
    AdminApi.exportScores()
    .then(
      (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "scores.csv"
        );
        document.body.appendChild(link);
        link.click();
        //window.location.href = response.url;
      }
    );
  }

  exportApps = () => {
    AdminApi.exportApps()
    .then(
      (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "applications.csv"
        );
        document.body.appendChild(link);
        link.click();
        //window.location.href = response.url;
      }
    );
  }

  render() {
    return (
      <div>
        {this.state.loading && (
          <Dimmer active={this.state.loading} page>
            <Loader>Fetching Data</Loader>
          </Dimmer>
        )}
        {!this.state.loading && (
          <div>
            <div style={{ display: "flex", padding: "1.2rem 1.5rem" }}>
              <Button as={Link} to="/dashboard" floated="left" color="blue">
                Dashboard
              </Button>
              <Header
                as="h1"
                textAlign="center"
                style={{ height: "1em", margin: "auto" }}
              >
                GOD MODE
              </Header>
              <Button
                color="orange"
                as={Link}
                to="/login"
                floated="right"
                onClick={Storage.logOut}
              >
                Log Out
              </Button>
            </div>
            <Grid columns={3}>
              <Grid.Column width={2} />
              <Grid.Column width={12}>
                {/* <br />
                <Header>Round Control</Header>
                <SettingsControl settings={this.state.settings} />
                <br /> */}
                <Header>Round Control</Header>
                <Segment>
                  <Grid columns={2} divided>
                    <Grid.Row verticalAlign="middle">
                      <Grid.Column>
                        <Statistic size="large" color="orange">
                          <Statistic.Label>Current Round:</Statistic.Label>
                          <Statistic.Value>
                            {this.state.current_round.round_number}
                          </Statistic.Value>
                        </Statistic>
                      </Grid.Column>
                      <Grid.Column>
                        <RoundChanger
                          rounds={this.state.rounds}
                          handleChangeRound={this.handleChangeRound}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
                <br />
                <Header>Run FAIR algorithm</Header>
                {/* ADD THRESHOLD PANEL HERE */}
                <ScoringConstantControl 
                  downloadAdmitData = {this.downloadAdmitData}
                  exportScores = {this.exportScores}
                  exportApps = {this.exportApps}
                  />
                {/* <Segment>
                  Target # Admits
                  <Input type="text" value={this.state.target_num} onChange={this.handleNumberChange} />
                  <br/>
                  <Button
                    color="green"
                    as={Link}
                    to="/admin/scoring/generate-scores"
                    onClick={this.downloadAdmitData}
                  >
                    Generate CSV
                  </Button>
                </Segment> */}
                
                <br />
                <Header>Import Data</Header>
                <Segment>
                  <Grid columns={2} divided>
                    <Grid.Row verticalAlign="middle">
                      <Grid.Column>
                        <ImportFromQuill style={{ verticleAlign: "middle" }} />
                      </Grid.Column>
                      <Grid.Column>
                        <RoundController />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>

                <br />
                <Header>Rounds</Header>
                <RoundsTable
                  refresh={this.refresh}
                  data={this.state.rounds}
                  current={this.state.current_round}
                />

                <br />
                <Header>
                  Graders (Active: {this.state.rounds[0].active_users})
                </Header>
                <UsersTable refresh={this.refresh} data={this.state.users} />
              </Grid.Column>
              <Grid.Column width={2} />
            </Grid>
          </div>
        )}
      </div>
    );
  }
}

export default AdminPage;



// WEBPACK FOOTER //
// ./src/components/admin/AdminPage.js